export const MOVIE_REQUEST = "MOVIE_REQUEST";
export const MOVIE_SUCCESS = "MOVIE_SUCCESS";
export const MOVIE_FAILURE = "MOVIE_FAILURE";
export const CLEAR_MOVIE = "CLEAR_MOVIE";
